import { Component } from '@angular/core';

@Component({
    selector: 'app-general-lists',
    templateUrl: './general-lists.component.html',
    styleUrl: './general-lists.component.scss',
    standalone: false
})
export class GeneralListsComponent {

}
